const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "[::1]"
);

export function register(config = {}) {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {

    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
    } else {
      registerValidSW(swUrl, config);
    }
  });
}


function registerValidSW(swUrl, config) {

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {

      console.log(
        "[PWA] Service worker registered:",
        registration.scope
      );

      registration.update();

      registration.addEventListener("updatefound", () => {

        const installingWorker =
          registration.installing;

        if (!installingWorker) {
          return;
        }

        installingWorker.addEventListener(
          "statechange",
          () => {

            if (
              installingWorker.state === "installed"
            ) {

              if (navigator.serviceWorker.controller) {

                console.log(
                  "[PWA] New version available."
                );

                if (config.onUpdate) {
                  config.onUpdate(registration);
                }

              } else {

                console.log(
                  "[PWA] Application ready for offline use."
                );

                if (config.onSuccess) {
                  config.onSuccess(registration);
                }
              }
            }
          }
        );
      });
    })
    .catch((error) => {
      console.error(
        "[PWA] Service worker registration failed:",
        error
      );
    });
}


function checkValidServiceWorker(swUrl, config) {

  fetch(swUrl, {
    headers: {
      "Service-Worker": "script"
    }
  })
    .then((response) => {

      const contentType =
        response.headers.get("content-type");

      if (
        response.status === 404 ||
        (
          contentType &&
          !contentType.includes("javascript")
        )
      ) {

        navigator.serviceWorker
          .ready
          .then((registration) => {
            registration.unregister().then(() => {
              window.location.reload();
            });
          });

        return;
      }

      registerValidSW(swUrl, config);
    })
    .catch(() => {
      console.log(
        "[PWA] No internet connection. Running cached application."
      );
    });
}


export function unregister() {

  if ("serviceWorker" in navigator) {

    navigator.serviceWorker
      .ready
      .then((registration) => {
        registration.unregister();
      });
  }
}